import React from "react";
import { 
  Box, VStack, HStack, Button, Icon,
  Stat, StatLabel, StatNumber, StatHelpText, 
  Progress, Tooltip
} from "@chakra-ui/react";
import { FaSave, FaPlusCircle, FaMagic } from "react-icons/fa";

const CharacterCounter = ({
  totalCharacters,
  characterLimit = 30000,
  isSaved,
  handleSaveContextText,
  setIsModalOpen,
  onAutoSelect
}) => {
  const characterPercentage = Math.min((totalCharacters / characterLimit) * 100, 100);
  
  return (
    <Box 
      flex={1} 
      bg="inherit"
      p={5}
      borderRadius="xl"
      boxShadow="sm"
    >
      <VStack spacing={4} align="stretch">
        <Stat>
          <StatLabel color="gray.500">Character Count</StatLabel>
          <StatNumber fontSize="3xl" color={totalCharacters > characterLimit ? "red.500" : "green.500"}>
            {totalCharacters.toLocaleString()}
          </StatNumber>
          <StatHelpText>
            {totalCharacters > characterLimit 
              ? `${(totalCharacters - characterLimit).toLocaleString()} characters over limit` 
              : `${(characterLimit - totalCharacters).toLocaleString()} characters remaining`}
          </StatHelpText>
        </Stat>
        
        <Progress 
          value={characterPercentage} 
          colorScheme={totalCharacters > characterLimit ? "red" : "green"} 
          size="sm"
          borderRadius="md"
          hasStripe
        />
        
        <HStack spacing={2}>
          <Button
            leftIcon={<FaSave />}
            onClick={handleSaveContextText}
            colorScheme={isSaved ? "green" : "blue"}
            variant="solid"
            flex={1}
            borderRadius="md"
            size="md"
          >
            {isSaved ? "Saved!" : "Save Context"}
          </Button>
          
          <Tooltip label="Auto-select optimal pages within character limit">
            <Button
              leftIcon={<FaMagic />}
              onClick={onAutoSelect}
              colorScheme="teal"
              variant="solid"
              size="md"
              borderRadius="md"
            >
              Auto-Select
            </Button>
          </Tooltip>
          
          <Button
            leftIcon={<FaPlusCircle />}
            onClick={() => setIsModalOpen(true)}
            colorScheme="purple"
            variant="solid"
            flex={1}
            borderRadius="md"
            size="md"
          >
            Add Custom
          </Button>
        </HStack>
      </VStack>
    </Box>
  );
};

export default CharacterCounter;